import { CSSProperties } from 'react';
import styled from 'styled-components';

import { BodilColor, NorlysColor, NorlysFont } from '~src/branding';
import { HEADER_HEIGHT } from '~src/branding/constants';

const LOGO_STYLE: CSSProperties = {
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)',
  width: '290px',
};

const Header = styled.div({
  position: 'fixed',
  width: '100%',
  height: HEADER_HEIGHT,
  zIndex: 100,
  padding: '0 60px 0 0',
  display: 'flex',
  flexFlow: 'row wrap',
  justifyContent: 'flex-end',
  alignItems: 'center',
});

export const HeaderBodil = styled(Header)({
  backgroundColor: BodilColor.base.default,
});

export const HeaderNorlys = styled(Header)({
  backgroundColor: 'white',
  padding: '0 60px 0 0',
  borderBottom: `2px dotted ${NorlysColor.secondary.darkGreen}`,
});

export const Logo = styled.img({
  ...LOGO_STYLE,
});

export const LogoWrapperEDC = styled.div<{ isMobile: boolean }>(({ isMobile }) => ({
  ...LOGO_STYLE,
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  gap: '8px',
  marginLeft: '8px',
  left: isMobile ? '20px' : '60px',
}));

export const LogoSubtitleEDC = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'flex-end',
  gap: '8px',
  color: '#819999',
});

export const LogoEDC = styled.img({
  width: '120px',
});

export const LogoWrapperNorlys = styled.div({
  ...LOGO_STYLE,
});

export const LogoNorlys = styled.img({
  width: '120px',
});

export const LogoSubtitleNorlys = styled.div({
  ...NorlysFont.style('default', 12),
  marginLeft: '8px',
  color: '#A4A4A4',
});
